// Distribution and wave motion adapted from Tyton's site-grid-pattern.ts.
// My Alpha uses its own theme ink and a quieter peak opacity in PixelField.
export const GRID_PERIOD = 12;
export const GRID_SQUARE = 4;

function hash01(a, b) {
  let h = (a * 374761393 + b * 668265263) | 0;
  h = Math.imul(h ^ (h >>> 13), 1274126177);
  return ((h ^ (h >>> 16)) >>> 0) / 4294967296;
}

export function createGridRow(cols, row) {
  const cells = [];
  for (let i = 0; i < cols; i++) {
    const nx = (i + 0.5) / cols;
    const d = Math.abs(nx - 0.5);
    if (d < 0.14 + 0.05 * hash01(i + 3, row + 9)) continue;
    const band = Math.floor(nx * 12);
    const chunk = Math.floor(row / 12);
    const bandNoise = hash01(band * 13 + 900, chunk * 7 + 500);
    const blob = hash01(Math.floor(i / 5) + 31, Math.floor(row / 5) + 17);
    const probability = Math.min(1, bandNoise * bandNoise * (0.55 + d * 1.1) * (0.35 + 1.3 * blob));
    if (hash01(i + 101, row + 202) >= probability) continue;
    cells.push({
      x: i * GRID_PERIOD,
      base: 0.3 + 0.7 * hash01(i + 11, row + 33),
      speed: 0.4 + 2.6 * hash01(i + 71, row + 97),
      phase: hash01(i + 5, row + 55) * Math.PI * 2,
      last: -1,
    });
  }
  return cells;
}

export function gridOpacity(cell, time, reduced, peak) {
  const wave = reduced ? 0.7 : 0.5 + 0.5 * Math.sin((time / 1000) * cell.speed + cell.phase);
  return peak * cell.base * wave * wave;
}
